const Next = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M1.94721 1.53262L13.0931 7.10557C13.8302 7.4741 13.8302 8.5259 13.0931 8.89443L1.94721 14.4674C1.28231 14.7998 0.5 14.3163 0.5 13.5729L0.5 2.42705C0.5 1.68367 1.28231 1.20017 1.94721 1.53262Z"
        fill="#433E3E"
        stroke="#433E3E"
      />
    </svg>
  );
};

export default Next;
